(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import axios from '@nextcloud/axios';
export var ShareType;

(function (ShareType) {
  ShareType[ShareType["User"] = 0] = "User";
  ShareType[ShareType["Group"] = 1] = "Group";
  ShareType[ShareType["Circle"] = 7] = "Circle";
})(ShareType || (ShareType = {}));

export var Permission;

(function (Permission) {
  Permission[Permission["Admin"] = 0] = "Admin";
  Permission[Permission["Moderator"] = 1] = "Moderator";
  Permission[Permission["User"] = 2] = "User";
})(Permission || (Permission = {}));

export var Access;

(function (Access) {
  Access["Public"] = "public";
  Access["Password"] = "password";
  Access["WaitingRoom"] = "waiting_room";
  Access["WaitingRoomAll"] = "waiting_room_all";
  Access["Internal"] = "internal";
  Access["InternalRestricted"] = "internal_restricted";
})(Access || (Access = {}));

var Api = /*#__PURE__*/function () {
  function Api() {
    _classCallCheck(this, Api);
  }

  _createClass(Api, [{
    key: "getUrl",
    value: function getUrl(endpoint) {
      return OC.generateUrl("apps/bbb/".concat(endpoint));
    }
  }, {
    key: "getRestriction",
    value: function getRestriction() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return axios.get(this.getUrl('restrictions/user'));

              case 2:
                response = _context.sent;
                return _context.abrupt("return", response.data);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getRestrictions",
    value: function getRestrictions() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return axios.get(this.getUrl('restrictions'));

              case 2:
                response = _context2.sent;
                return _context2.abrupt("return", response.data);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "createRestriction",
    value: function createRestriction(groupId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return axios.post(this.getUrl('restrictions'), {
                  groupId: groupId
                });

              case 2:
                response = _context3.sent;
                return _context3.abrupt("return", response.data);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "updateRestriction",
    value: function updateRestriction(restriction) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var newRestriction, response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (restriction.id) {
                  _context4.next = 5;
                  break;
                }

                _context4.next = 3;
                return this.createRestriction(restriction.groupId);

              case 3:
                newRestriction = _context4.sent;
                restriction.id = newRestriction.id;

              case 5:
                _context4.next = 7;
                return axios.put(this.getUrl("restrictions/".concat(restriction.id)), restriction);

              case 7:
                response = _context4.sent;
                return _context4.abrupt("return", response.data);

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "deleteRestriction",
    value: function deleteRestriction(id) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var response;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return axios.delete(this.getUrl("restrictions/".concat(id)));

              case 2:
                response = _context5.sent;
                return _context5.abrupt("return", response.data);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "isRunning",
    value: function isRunning(uid) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var response;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return axios.get(this.getUrl("server/".concat(uid, "/isRunning")));

              case 2:
                response = _context6.sent;
                return _context6.abrupt("return", response.data);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "insertDocument",
    value: function insertDocument(uid, url, filename) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var response;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return axios.post(this.getUrl("server/".concat(uid, "/insertDocument")), {
                  url: url,
                  filename: filename
                });

              case 2:
                response = _context7.sent;
                return _context7.abrupt("return", response.data);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "getRoomUrl",
    value: function getRoomUrl(room) {
      var forModerator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var _a;

      var shortener = ((_a = document.getElementById('bbb-root')) === null || _a === void 0 ? void 0 : _a.getAttribute('data-shortener')) || '';
      var token = forModerator && room.moderatorToken ? "".concat(room.uid, "/").concat(room.moderatorToken) : room.uid;

      if (shortener) {
        return shortener.replace(/\{user\}/g, room.userId).replace(/\{token\}/g, token);
      }

      return window.location.origin + api.getUrl("b/".concat(token));
    }
  }, {
    key: "getRooms",
    value: function getRooms() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var response;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return axios.get(this.getUrl('rooms'));

              case 2:
                response = _context8.sent;
                return _context8.abrupt("return", response.data);

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "createRoom",
    value: function createRoom(name) {
      var access = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Access.Public;
      var maxParticipants = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var response;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return axios.post(this.getUrl('rooms'), {
                  name: name,
                  welcome: '',
                  maxParticipants: maxParticipants,
                  record: false,
                  access: access
                });

              case 2:
                response = _context9.sent;
                return _context9.abrupt("return", response.data);

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "updateRoom",
    value: function updateRoom(room) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var response;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return axios.put(this.getUrl("rooms/".concat(room.id)), room);

              case 2:
                response = _context10.sent;
                return _context10.abrupt("return", response.data);

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "deleteRoom",
    value: function deleteRoom(id) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var response;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return axios.delete(this.getUrl("rooms/".concat(id)));

              case 2:
                response = _context11.sent;
                return _context11.abrupt("return", response.data);

              case 4:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));
    }
  }, {
    key: "getRecordings",
    value: function getRecordings(uid) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var response;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return axios.get(this.getUrl("server/".concat(uid, "/records")));

              case 2:
                response = _context12.sent;
                return _context12.abrupt("return", response.data);

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));
    }
  }, {
    key: "deleteRecording",
    value: function deleteRecording(id) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var response;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return axios.delete(this.getUrl("server/record/".concat(id)));

              case 2:
                response = _context13.sent;
                return _context13.abrupt("return", response.data);

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));
    }
  }, {
    key: "storeRecording",
    value: function storeRecording(recording, path) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var startDate, filename, url;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                startDate = new Date(recording.startTime);
                filename = "".concat(encodeURIComponent(recording.name + ' ' + startDate.toISOString()), ".url");
                url = OC.linkToRemote("dav/files/".concat(OC.currentUser).concat(path, "/").concat(filename));
                _context14.next = 5;
                return axios.put(url, "[InternetShortcut]\nURL=".concat(recording.url));

              case 5:
                return _context14.abrupt("return", filename);

              case 6:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));
    }
  }, {
    key: "storeRoom",
    value: function storeRoom(room, path) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var filename, url;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                filename = "".concat(encodeURIComponent(room.name), ".url");
                url = OC.linkToRemote("dav/files/".concat(OC.currentUser).concat(path, "/").concat(filename));
                _context15.next = 4;
                return axios.put(url, "[InternetShortcut]\nURL=".concat(this.getRoomUrl(room)));

              case 4:
                return _context15.abrupt("return", filename);

              case 5:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));
    }
  }, {
    key: "checkServer",
    value: function checkServer(url, secret) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        var response;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return axios.post(this.getUrl('server/check'), {
                  url: url,
                  secret: secret
                });

              case 2:
                response = _context16.sent;
                return _context16.abrupt("return", response.data);

              case 4:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));
    }
  }, {
    key: "getRoomShares",
    value: function getRoomShares(roomId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        var response;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return axios.get(this.getUrl('roomShares'), {
                  params: {
                    id: roomId
                  }
                });

              case 2:
                response = _context17.sent;
                return _context17.abrupt("return", response.data);

              case 4:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));
    }
  }, {
    key: "createRoomShare",
    value: function createRoomShare(roomId, shareType, shareWith, permission) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        var response;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return axios.post(this.getUrl('roomShares'), {
                  roomId: roomId,
                  shareType: shareType,
                  shareWith: shareWith,
                  permission: permission
                });

              case 2:
                response = _context18.sent;
                return _context18.abrupt("return", response.data);

              case 4:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));
    }
  }, {
    key: "deleteRoomShare",
    value: function deleteRoomShare(id) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
        var response;
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return axios.delete(this.getUrl("roomShares/".concat(id)));

              case 2:
                response = _context19.sent;
                return _context19.abrupt("return", response.data);

              case 4:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));
    }
  }, {
    key: "getRecommendedShareWith",
    value: function getRecommendedShareWith() {
      var shareType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [OC.Share.SHARE_TYPE_USER, OC.Share.SHARE_TYPE_GROUP];
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
        var url, response;
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                url = OC.linkToOCS('apps/files_sharing/api/v1', 1) + 'sharees_recommended';
                _context20.next = 3;
                return axios.get(url, {
                  params: {
                    shareType: shareType,
                    itemType: 'room',
                    format: 'json'
                  }
                });

              case 3:
                response = _context20.sent;
                return _context20.abrupt("return", {
                  users: [],
                  groups: [],
                  circles: [],
                  exact: {
                    users: response.data.ocs.data.exact.users,
                    groups: response.data.ocs.data.exact.groups,
                    circles: response.data.ocs.data.exact.circles || []
                  }
                });

              case 5:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20);
      }));
    }
  }, {
    key: "searchShareWith",
    value: function searchShareWith() {
      var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var shareType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [OC.Share.SHARE_TYPE_USER, OC.Share.SHARE_TYPE_GROUP];
      return __awaiter(this, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
        var url, response, data;
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                url = OC.linkToOCS('apps/files_sharing/api/v1', 1) + 'sharees';
                _context21.next = 3;
                return axios.get(url, {
                  params: {
                    search: search,
                    shareType: shareType,
                    itemType: 'room',
                    format: 'json',
                    lookup: false
                  }
                });

              case 3:
                response = _context21.sent;
                data = response.data.ocs.data;
                return _context21.abrupt("return", {
                  users: data.users,
                  groups: data.groups,
                  circles: data.circles || [],
                  exact: {
                    users: data.exact.users,
                    groups: data.exact.groups,
                    circles: data.exact.circles || []
                  }
                });

              case 6:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21);
      }));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    value: // @ts-ignore
    function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return Api;
}();

export var api = new Api();
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(__awaiter, "__awaiter", "/home/klaus/Repos/cloud_bbb/ts/Common/Api.ts");
  reactHotLoader.register(ShareType, "ShareType", "/home/klaus/Repos/cloud_bbb/ts/Common/Api.ts");
  reactHotLoader.register(Permission, "Permission", "/home/klaus/Repos/cloud_bbb/ts/Common/Api.ts");
  reactHotLoader.register(Access, "Access", "/home/klaus/Repos/cloud_bbb/ts/Common/Api.ts");
  reactHotLoader.register(Api, "Api", "/home/klaus/Repos/cloud_bbb/ts/Common/Api.ts");
  reactHotLoader.register(api, "api", "/home/klaus/Repos/cloud_bbb/ts/Common/Api.ts");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();